"use client";

import { RequireAuth } from "@/components/require-auth";
import { FBAProvider } from "@/context/functionalBehaviorAnalysisContext";
import Sidebar from "@/components/sidebar";
import { usePathname } from "next/navigation";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as SonnerToaster } from "@/components/ui/sonner";
import { RequireBeta } from "@/components/require-beta";

export function AppShell({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  const isPublic = pathname === "/" || pathname === "/login" || pathname === "/beta-required" || pathname?.startsWith("/auth");

  if (isPublic) {
    return (
      <>
        <main className="flex-1 p-4 md:p-6">{children}</main>
        <Toaster />
        <SonnerToaster />
      </>
    );
  }

  return (
    <RequireAuth>
      <RequireBeta>
        <FBAProvider>
          <div className="flex flex-1">
            <Sidebar />
            <main className="flex-1 p-4 md:p-6">{children}</main>
          </div>
          <Toaster />
          <SonnerToaster />
        </FBAProvider>
      </RequireBeta>
    </RequireAuth>
  );
}


